(function() {
    'use strict';
    angular.module('wamasysApp').factory('ReportingZoneAnalysis', service);
    service.$inject = ['$resource'];
    function service($resource) {
        var url = 'api/reporting-zone-analysis';
        return $resource(url, {}, {
            overview: {method: 'GET'},
            prompts: {method: 'GET', url: url + '/prompts', isArray: true},
            savePrompt: {method: 'POST', url: url + '/prompts'},
            history: {method: 'GET', url: url + '/analyses', isArray: true},
            detail: {method: 'GET', url: url + '/analyses/:id'},
            run: {method: 'POST', url: url + '/analyses'}
        });
    }
})();
